import { ResponseError } from 'types/error.types';
import { Status } from 'redux/types/state.interface';
import { StoresState } from 'redux/types/store.types';
import { createSlice } from '@reduxjs/toolkit';
import { getAvailableStoresForDelivery } from 'redux/PDP/availability/for-delivery/delivery.actions';

const initialState: StoresState = {
  data: [],
  status: Status.INIT,
  error: null,
};

const deliverySlice = createSlice({
  name: 'delivery',
  initialState,
  reducers: {
    setStoresAvailableForDeliveryInitialState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAvailableStoresForDelivery.pending, () => ({
        ...initialState,
        status: Status.PENDING,
      }))
      .addCase(
        getAvailableStoresForDelivery.fulfilled,
        (state, { payload }) => {
          state.status = Status.FULFILLED;
          state.data = payload;
        },
      )
      .addCase(getAvailableStoresForDelivery.rejected, (state, { payload }) => {
        state.status = Status.ERROR;
        state.error = payload as ResponseError;
      })
      .addDefaultCase((state) => state);
  },
});

export const { reducer: deliveryReducer } = deliverySlice;
